import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Organization owners can require organization members to enable two-factor authentication for their personal accounts, making it harder for malicious actors to access an organization's packages and settings`}</p>
    <h2>{`About two-factor authentication for organizations`}</h2>
    <p>{`Two-factor authentication (2FA) is an extra layer of security used when logging into websites or apps. You can require all members in your organization to enable two-factor authentication on npm. For more information about two-factor authentication, see `}<a parentName="p" {...{
        "href": "configuring-two-factor-authentication"
      }}>{`"Configuring two-factor authentication."`}</a>{`.`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong></p>
      <ul>
        <li parentName="ul">{`When you require use of two-factor authentication for your organization, members who do not use 2FA will be removed from the organization and lose access to its packages. You can add them back to the organization if they enable two-factor authentication.`}</li>
        <li parentName="ul">{`An organization owner cannot opt-in to requiring 2FA for an organization if they do not have 2FA enabled on their account.`}</li>
        <li parentName="ul">{`If you are the member of an organization that requires 2FA you will not be able to disable 2FA until you leave that organization.`}</li>
      </ul>
    </Note>
    <h2>{`Prerequisites`}</h2>
    <p>{`Before you can require organization members to use two-factor authentication, you must enable two-factor authentication for your account on npm. For more information, see `}<a parentName="p" {...{
        "href": "configuring-two-factor-authentication"
      }}>{`"Configuring two-factor authentication."`}</a>{`.`}</p>
    <p>{`Before you require use of two-factor authentication, we recommend notifying organization members and asking them to set up 2FA for their accounts. You can see if members already use 2Fa in the organizations members page.`}</p>
    <h2>{`Requiring two-factor authentication in your organization`}</h2>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['account-settings'].text}</>
        <>{shared['account-settings'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-selection'].text}</>
        <>{shared['organization-selection'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-members-tab'].text}</>
        <>{shared['organization-members-tab'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click the `}<strong parentName="p">{`Enable 2FA Enforcement`}</strong>{` button.`}</p>
        <Screenshot src="/organizations/requiring-two-factor-authentication-in-your-organization/enable-2fa.png" alt="Screenshot of the enforce 2fa button" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`If prompted, read the information about members who will be removed from the organization. Type your organization's name to confirm the change, then click Remove members & require two-factor authentication.`}</p>
        <Screenshot src="/organizations/requiring-two-factor-authentication-in-your-organization/removal-confirmation.png" alt="Screenshot of the removal confirmation prompt" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`If any members are removed from the organization, we recommend sending them an invitation that can reinstate their former privileges and access to your organization. They must enable two-factor authentication before they can accept your invitation.`}</p>
      </li>
    </ol>
    <h2>{`Helping removed members and outside collaborators rejoin your organization`}</h2>
    <p>{`If any members are removed from the organization when you enable required use of two-factor authentication, they'll receive an email notifying them that they've been removed. They should then enable 2FA for their personal account, and contact an organization owner to request access to your organization.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      